(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trJoin', trJoin);

  function trJoin() {
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'JoinController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/auth/affiliate-password.view.html'
    };
    return directive;
  }
})();
